import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { useUserProfile } from '@office-start/harmony-data-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import React, { useContext, useEffect, useMemo } from 'react';
import { SearchInstrumenter, SearchMainModule, SearchModules, SearchPrefetch, } from './modules';
import { SearchSettings } from './settings';
var SearchPageBootstrapperContext = React.createContext(undefined);
/**
 * Context provider for Search integration.
 * It contains all the modules and settings needed for Search integration, such as
 * instances for: `SearchSettings`, `SearchModules`, `SearchInstrumenter`,
 * `SearchPrefetch`, and `SearchMainModule`.
 */
export function SearchPageBootstrapperProvider(_a) {
    var children = _a.children;
    var isStandaloneCopilotPage = useStandaloneCopilotApp();
    var searchSettings = useMemo(function () { return new SearchSettings(); }, []);
    var searchModules = useMemo(function () { return new SearchModules(searchSettings); }, [searchSettings]);
    var searchInstrumenter = useMemo(function () { return new SearchInstrumenter(searchSettings, searchModules); }, [searchSettings, searchModules]);
    var searchPrefetch = useMemo(function () { return new SearchPrefetch(searchSettings, searchModules); }, [searchSettings, searchModules]);
    var userProfile = useUserProfile();
    var searchMainModule = useMemo(function () {
        return new SearchMainModule({
            searchSettings: searchSettings,
            searchModules: searchModules,
            searchPrefetch: searchPrefetch,
            searchInstrumenter: searchInstrumenter,
            userProfile: userProfile,
        });
    }, [
        searchSettings,
        searchModules,
        searchPrefetch,
        searchInstrumenter,
        userProfile,
    ]);
    useEffect(function () {
        if (isStandaloneCopilotPage) {
            return;
        }
        if (AppbarConnectorService.getInstance().getIsCopilotChatExperience()) {
            // Schedule the initialization with lowespt priority
            scheduleWork(function () {
                searchSettings.initialize();
            }, IDLE_VERYLOW_PRIORITY, 'searchSettings');
        }
        else {
            searchSettings.initialize();
        }
    }, [searchSettings, isStandaloneCopilotPage]);
    return (React.createElement(SearchPageBootstrapperContext.Provider, { value: {
            searchSettings: searchSettings,
            searchModules: searchModules,
            searchInstrumenter: searchInstrumenter,
            searchPrefetch: searchPrefetch,
            searchMainModule: searchMainModule,
        } }, children));
}
/**
 * Hook to get the Search integration context.
 */
export function useSearchPageBootstrapperContext() {
    var context = useContext(SearchPageBootstrapperContext);
    if (!context) {
        throw new Error('useSearchPageBootstrapperContext must be used within a SearchPageBootstrapperProvider');
    }
    return context;
}
//# sourceMappingURL=SearchPageBootstrapperProvider.js.map